module.exports = __webpack_public_path__ + "img/Norfolk Island.3a9a88dc.svg";